import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';

const TeacherViewLazy = React.lazy(
	() =>
		import(/* webpackChunkName : 'CalendarsLazy' */ './components/TeacherView')
);

export default (store) => {
	return {
		path: 'teacher-view/:campusId?',
		element: <AsyncLoading component={<TeacherViewLazy />} />,
		children: [],
	};
};
